export default __webpack_public_path__ + "static/media/background-6.13d679af.png";